import { FeatureFlags } from '@shared/utils/constants';
import { isMeratusTcOut } from '@shared/utils/meratus';
import useFeatureFlag from '@client/utils/hooks/useFeatureFlag';

const useIsMeratusTcOut = (fixtureType?: string | null) => {
	const isMeratus = useFeatureFlag(FeatureFlags.MERATUS);

	return isMeratusTcOut(isMeratus, fixtureType ?? '');
};

export default useIsMeratusTcOut;
